import { createFileRoute, notFound } from "@tanstack/react-router";
import { ServiceDetailPage } from "@/components/sections/service-detail";
import { LOCAL_SEO_SERVICES, RELATED_LOCAL_SEO } from "@/lib/marketing-services";
import { buildServiceHead } from "@/lib/service-seo";

export const Route = createFileRoute("/marketing/local-seo/$slug")({
  component: LocalSeoServicePage,
  loader: ({ params }) => {
    const detail = LOCAL_SEO_SERVICES.find((s) => s.slug === params.slug);
    if (!detail) throw notFound();
    return { detail };
  },
  head: ({ loaderData }) =>
    buildServiceHead(loaderData?.detail, {
      label: "Local SEO",
      basePath: "/marketing/local-seo",
    }),
});

function LocalSeoServicePage() {
  const { detail } = Route.useLoaderData();
  return (
    <ServiceDetailPage
      detail={detail}
      categoryLabel="Local SEO"
      categoryHref="/marketing/local-seo"
      related={RELATED_LOCAL_SEO}
    />
  );
}
